/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandXbox = createReactComponent("outline", "brand-xbox", "IconBrandXbox", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M6.5 5c7.72 2.266 10.037 7.597 12.5 12.5", "key": "svg-1" }], ["path", { "d": "M17.5 5c-7.72 2.266 -10.037 7.597 -12.5 12.5", "key": "svg-2" }]]);

export { IconBrandXbox as default };
//# sourceMappingURL=IconBrandXbox.mjs.map
